import en from './en';
import fr from './fr';
import es from './es';
import ar from './ar';
import pt from './pt';
import hi from './hi';
import zh from './zh';
import id from './id';
import ru from './ru';
import sw from './sw';

export { languageOptions, type LanguageCode } from './types';

export const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  ar: { translation: ar },
  pt: { translation: pt },
  hi: { translation: hi },
  zh: { translation: zh },
  id: { translation: id },
  ru: { translation: ru },
  sw: { translation: sw },
} as const;
